/**
 * Replacement / vouch policy copy — keep Terms, refund page, buyer flows, and staff blurbs aligned.
 */

export const PulseDigital_VOUCHES_CHANNEL = '#vouches'
export const PulseDigital_VOUCHES_CHANNEL_URL =
  'https://discord.com/channels/1492413122101641379/1492931338456662056'
export const VOUCH_POST_DEADLINE_HOURS = 24

/** Plain-text channel reference (includes link for tickets, SMS, Discord paste). */
export function vouchesChannelText(includeUrl = true): string {
  return includeUrl ? `${PulseDigital_VOUCHES_CHANNEL} (${PulseDigital_VOUCHES_CHANNEL_URL})` : PulseDigital_VOUCHES_CHANNEL
}

export const REPLACEMENT_POLICY_ONE_LINER = `Post your vouch in ${vouchesChannelText()} within 24 hours of delivery to activate warranty; your replacement window runs from that vouch (length varies by product — Terms §2). Report dead-on-arrival issues in your ticket before vouching.`

/** Buyer-facing reminder after staff delivers (short). */
export function buyerPostDeliveryReminder(): string {
  return `After we deliver, test your order. If it works, post in ${vouchesChannelText()} within ${VOUCH_POST_DEADLINE_HOURS} hours to activate your replacement window. If it failed on first use, reply in your ticket before vouching — do not vouch a broken delivery.`
}

/** Template buyers paste into the vouch channel. */
export function buildVouchPostTemplate(orderId: string, productSummary: string): string {
  const id = orderId.trim() || '(your order ID)'
  const product = productSummary.trim() || '(product name)'
  return `Order ID: ${id}
Product: ${product}
Status: Received & working`
}

/** Staff paste after posting credentials / access in a ticket. */
export function staffPostDeliveryBlurb(orderId: string, productSummary: string): string {
  const id = orderId.trim() || '(order ID)'
  const product = productSummary.trim() || '(product)'
  const vouchExample = buildVouchPostTemplate(id, product)
  return `✅ Delivered — please read:

If it does NOT work: reply in this ticket BEFORE vouching (dead on arrival). Do not vouch a broken delivery.

If it works: post your vouch in ${vouchesChannelText()} within ${VOUCH_POST_DEADLINE_HOURS} hours of this message to activate your warranty:

${vouchExample}

Your replacement window starts when you vouch (usually 24 hours from vouch for most listings; longer or shorter windows in Terms §2). No vouch within ${VOUCH_POST_DEADLINE_HOURS}h of delivery = warranty not activated.`
}
